// import styled from 'styled-components';
// import { darken } from 'polished';

// export const Action = styled.div`
//   display: flex;
//   align-items: center;
// `;

// Action.BtnSquare = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-left: 15px;
//   border: 0;
//   border-radius: 5px;
//   height: 42px;
//   width: 50px !important;

//   &.btn-nav-ref {
//     background: none;
//     color: #cbd0d8;
//     transition: all 1s;

//     &:hover {
//       background: ${darken(0.1, '#f2f5fc')};
//       color: ${darken(0.1, '#1789dd')};
//       /* transform: scale(1.1); */
//     }
//   }
// `;

import styled from 'styled-components';
import { darken } from 'polished';

export const Action = styled.div`
  display: flex;
  align-items: center;
`;

/**
 * Botões de navegação entre os processos (Classificação, Extração,
 * Edição, Mapeamento). Compartilhados pelas três telas do editor.
 *
 * Reduzidos junto com a barra de título compacta: 42x50 abria a faixa
 * mais do que o título precisava.
 */
Action.BtnSquare = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  border: 0;
  border-radius: 8px;
  height: 32px;
  width: 38px !important;

  &.btn-nav-ref {
    background: none;
    color: #cbd0d8;
    transition: all 1s;

    &:hover {
      background: ${darken(0.1, '#f2f5fc')};
      color: ${darken(0.1, '#1789dd')};
      /* transform: scale(1.1); */
    }
  }
`;
